import board1 from "../Assets/Board-CasualPuzzles.svg";
import board2 from "../Assets/Board-PersonalisedPuzzles.svg";
import board3 from "../Assets/Board-ClassicalPuzzles.svg";
const puzzles = [
  {
    id: 1,
    image: board1,
    title: "Casual puzzles",
    path: "/CasualPuzzles",
  },
  {
    id: 2,
    image: board2,
    title: "Personalised puzzles",
    path: "/PersonalisedPuzzles",
  },
  {
    id: 3,
    image: board3,
    title: "Classical puzzles",
    path: "/ClassicalPuzzles",
  },
  {
    id: 4,
    image: board1,
    title: "Visualisation puzzles",
    path: "/VisualisationPuzzles",
  },
  {
    id: 5,
    image: board2,
    title: "Top game puzzles",
    path: "/TopGamePuzzles",
  },
  {
    id: 6,
    image: board3,
    title: "Smart puzzles",
    path: "/SmartPuzzles",
  },
];

export default puzzles;
